module.exports = __webpack_public_path__ + "static/media/shareImage.6b8cdbed.png";